import { getDashColor } from '../../styles'
import {
  PRIMARY_BLUE_10,
  PRIMARY_RED_01,
  PRIMARY_RED_10,
  SECONDARY_BLUE_10,
  SECONDARY_GREEN_01,
  SECONDARY_GREEN_10,
  SECONDARY_ORANGE_10,
  SECONDARY_YELLOW_10,
  WHITE,
} from 'bd-web-components/src/utils/dash-colors'
import styled, { css } from 'styled-components'
import CalendarDashboard from '../../components/Calendar'
// Loader and error ------------------------------------------------

interface ExceptionContainerProps {
  height: number
  margin: boolean
}

export const ExceptionContainer = styled(styled.div``) <ExceptionContainerProps>`
  display: flex;
  justify-content: center;
  align-items: center;

  ${(props) =>
    props.height !== undefined &&
    css`
      height: ${props.height}px;
    `}
  ${(props) =>
    props.margin &&
    css`
      margin-bottom: 100px;
    `}
`

export const LoaderBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 150px;
  padding-bottom: 16px;
  @media (max-width: 768px) {
  }
`

// Header ---------------------------------------------------------------
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fefeff;
  width: 100%;
  max-width: 1325px;
  margin: 0 auto;
  padding: 0px 64px;
  height: 100%;
  @media (max-width: 768px) {
    padding: 0px 24px;
  }
`
export const PageHeaderBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 16px;
  @media (max-width: 768px) {
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    max-width: 100%;
  }
`
export const PageTitle = styled.h4`
  color: ${getDashColor('PRIMARY_BLUE_02', 'GRAY_DARK')};
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 35.2px; /* 110% */
  margin-top: 0px;
  margin-bottom: 8px;
  @media (max-width: 768px) {
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px; /* 110% */
    margin-top: 0px;
    margin-bottom: 5px;
  }
`

export const CalendarContiner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`
export const CalendarDashboardStyled = styled(CalendarDashboard)`
  background: ${WHITE};
  max-width: 100px;
  .CalendarIcon {
    background-color: black;
    filter: invert(1);
  }
  &.hidden {
    display: none;
  }
`

// Event Footer ---------------------------------------------------------------
export const TagContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-left: 35px;
  padding-right: 29px;
  padding-top: 17px;
  padding-bottom: 17px;
  @media (max-width: 768px) {
    padding-left: 25px;
    padding-right: 29px;
  }
`
export const TableTag = styled.p`
  color: ${getDashColor('PRIMARY_BLUE_02', 'GRAY_DARK')};
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  @media (max-width: 768px) {
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 13.5px;
  }
`
export const TableTagValue = styled.p`
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  @media (max-width: 768px) {
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 14.5px;
  }

  &.positive {
    color: ${SECONDARY_GREEN_01};
  }
  &.negative {
    color: ${PRIMARY_RED_01};
  }
`

export const ButtonBox = styled.div`
  padding-top: 10px;
  padding-left: 35px;
  padding-bottom: 20px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  @media (max-width: 768px) {
    padding-left: 20px;
  }
`

// Cards Main ----------------------------------------------------------

export const MainCard = styled.div`
  width: 49%;
  height: 127px;
  border-radius: 10px;
  border: 1.5px solid ${getDashColor('GRAY_SCALE_08', 'BEIGE')};
  background: ${WHITE};
  padding: 16px;
  display: flex;
  justify-content: flex-start;
  margin-bottom: 20px;
  padding-left: 40px;
  @media (max-width: 768px) {
    width: 100%;
    min-height: 97px;
    padding-left: 35px;
  }
`
export const MainCardDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: ${WHITE};
  @media (max-width: 768px) {
    flex-direction: column;
    height: auto !important;
  }
`

export const IconDetailContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  &:before {
    content: '';
    width: 48px;
    height: 48px;
    background-color: ${SECONDARY_BLUE_10};
    border-radius: 100px;
    position: absolute;
    z-index: 0;
  }
  & div {
    z-index: 1;
  }
  &.success {
    &:before {
      background-color: ${SECONDARY_GREEN_10};
    }
  }
  &.info {
    &:before {
      background-color: ${SECONDARY_BLUE_10};
    }
  }
`

export const LabelCard = styled.div`
  color: ${getDashColor('PRIMARY_BLUE_01', 'GRAY_DARK')};
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 26.6px;
  padding: 0 40px;
  align-content: center;
  @media (max-width: 768px) {
    font-size: 18px;
    line-height: 25.2px;
    font-weight: 600;
    padding: 0 50px;
  }
`

export const CardTitle = styled.div`
  color: ${getDashColor('PRIMARY_BLUE_02', 'GRAY_DARK')};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 19.6px;
  margin-bottom: 8px;
  @media (max-width: 768px) {
    font-size: 14px;
    margin-bottom: 4px;
    line-height: 25.6px;
  }
`
// Card Sub --------------------------------------------------

export const SubContainer = styled.div`
  width: 100%;
  height: 127px;
  border-radius: 10px;
  border: 1.5px solid ${getDashColor('GRAY_SCALE_08', 'BEIGE')};
  background: ${WHITE};
  padding: 16px;
  display: flex;
  justify-content: flex-start;
  margin-bottom: 20px;
  padding-left: 32px;
  overflow-x: auto;
  white-space: nowrap;
  @media (max-width: 768px) {
    flex-direction: column;
    height: auto !important;
    padding-left: 25px;
  }
`
export const SubCard = styled.div`
  width: 100%;
  background: ${WHITE};
  display: flex;
  align-items: center;
  justify-content: flex-start;
  @media (max-width: 768px) {
    flex-direction: row;
    height: 70px;
    margin-bottom: 20px;
  }
`

export const SubIconDetailContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 100px;
  z-index: 0;
  &.black {
    background-color: ${PRIMARY_BLUE_10};
  }
  &.red {
    background-color: ${PRIMARY_RED_10};
  }
  &.yellow {
    background-color: ${SECONDARY_YELLOW_10};
  }
  &.orange {
    background-color: ${SECONDARY_ORANGE_10};
  }
`

export const SubLabelCard = styled.div`
  color: ${getDashColor('PRIMARY_BLUE_01', 'GRAY_DARK')};
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 19.6px;
  padding: 0 32px;
  align-content: center;
  @media (max-width: 768px) {
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 19.6px;
    padding: 0 50px;
  }
`

export const SubCardTitle = styled.div`
  color: ${getDashColor('PRIMARY_BLUE_02', 'GRAY_DARK')};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 19.6px;
  margin-bottom: 8px;
  @media (max-width: 768px) {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 19.6px;
    margin-bottom: 4px;
  }
`

export const PageSubItens = styled.h4`
  color: ${getDashColor('PRIMARY_BLUE_02', 'GRAY_DARK')};
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 26.2px;
  margin-top: 32px;
  margin-bottom: 24px;
  @media (max-width: 768px) {
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    margin-top: 0px;
    margin-bottom: 12px;
  }
`

export const TableContainer = styled.h4`
  width: 100%;
  height: 100%;
  overflow-x: auto;
  padding: 10px;
  list-style: none;
  li::marker {
    content: none;
  }
`

export const SelectDateContainer = styled.div`
  display: flex;
  gap: 30px;
  font-weight: 500;
  position: relative;
  justify-content: space-between;
  max-width: 250px;
  &:before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background-color: ${getDashColor('GRAY_SCALE_08', 'BEIGE')};
  }
`

export const SelectDateText = styled.div`
  align-items: center;
  display: flex;
  height: 50px;
  cursor: pointer;
  position: relative;
  white-space: nowrap;
  color: ${getDashColor('GRAY_SCALE_05', 'GRAY_DARK')};
  &.active {
    color: ${getDashColor('BLACK', 'GRAY_DARK')};
    font-weight: 600;
  }
  &:hover {
    color: ${getDashColor('BLACK', 'GRAY_DARK')};
    font-weight: 600;
  }
  &:hover::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 3px;
     background-color: ${getDashColor('PRIMARY_RED_01', 'SECONDARY_COLOR')};
  }
  &.active::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 3px;
     background-color: ${getDashColor('PRIMARY_RED_01', 'SECONDARY_COLOR')};
  }
`
